import { IconWrapper } from '../runtime';
export default IconWrapper('shortcut', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M1.75 3.24969C1.75 2.42127 2.42157 1.74969 3.25 1.74969H12.75C13.5784 1.74969 14.25 2.42127 14.25 3.24969V12.7497C14.25 13.5781 13.5784 14.2497 12.75 14.2497H3.25C2.42157 14.2497 1.75 13.5781 1.75 12.7497V3.24969Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M8.41223 8.9115L9.24515 9.74442C9.54491 10.0442 10.0583 9.85831 10.0966 9.43613L10.4457 5.5968C10.4739 5.28583 10.2134 5.02532 9.90246 5.05359L6.06314 5.40262C5.64096 5.441 5.4551 5.95436 5.75485 6.25412L6.55027 7.04954C5.28351 8.31629 4.5 10.0663 4.5 11.9993C4.5 12.1765 4.50658 12.3521 4.51952 12.526C4.54273 12.838 4.9707 12.8596 5.09295 12.5716C5.75587 11.0096 6.93313 9.71874 8.41223 8.9115Z",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});